<template>
    <div class="range-slider" ref="slider-element"></div>
</template>

<script type="text/javascript">
import noUiSlider from 'nouislider';
import 'nouislider/distribute/nouislider.css';
import SliderMixin from './Mixins/SliderMixin.vue';

export default {
    mixins: [SliderMixin],

    props: ['values']
}
</script>
